export function openUrl (url:string, target:string) : void {
  window.open(url, target)
}
